export const UNFOLLOW_USER_MUTATION = `
  mutation UnfollowUserMutation($userId: ID!) {
    me {
      unfollowUser(userId: $userId) {
        id
        isVerified
        nickname
        image {
          id
          url(width: 64, height: 64)
        }
      }
    }
  }
`;
